import type { UserSchema } from "../types/auth.type";

export type PlatformPersonaSlug = "super_admin" | "platform_read_only" | "verifier";

export interface PlatformPersonaCatalogItem {
  slug: PlatformPersonaSlug;
  label: string;
  description: string;
  requires_super_admin_to_assign: boolean;
}

export interface UserPlatformPersonas {
  user_id: string;
  personas: PlatformPersonaSlug[];
  perm_ver: number;
}

export interface PlatformPersonasCatalogResponse {
  personas: PlatformPersonaCatalogItem[];
}

export const PLATFORM_PERSONA_LABELS: Record<PlatformPersonaSlug, string> = {
  super_admin: "Super admin",
  platform_read_only: "Platform read-only",
  verifier: "Verifier",
};

export function isPlatformPersonaSlug(value: string): value is PlatformPersonaSlug {
  return value === "super_admin" || value === "platform_read_only" || value === "verifier";
}

export function personasFromUser(user: Pick<UserSchema, "platform_personas"> | null | undefined): PlatformPersonaSlug[] {
  const raw = user?.platform_personas ?? [];
  return raw.filter(isPlatformPersonaSlug);
}

export function isVerifierPersona(personas?: readonly string[]): boolean {
  return personas?.includes("verifier") ?? false;
}

export function isSuperAdminPersona(personas?: readonly string[]): boolean {
  return personas?.includes("super_admin") ?? false;
}

export function isPlatformReadOnlyPersona(personas?: readonly string[]): boolean {
  return personas?.includes("platform_read_only") ?? false;
}

export function isVerifierFromJwt(payload: {
  platform?: { personas?: string[] };
} | null | undefined): boolean {
  return isVerifierPersona(payload?.platform?.personas);
}

export function isTokenPermVerStale(
  jwtPermVer: number | undefined,
  serverPermVer: number | undefined,
): boolean {
  if (serverPermVer === undefined || serverPermVer === null) {
    return false;
  }
  const jwtVer = jwtPermVer ?? 0;
  return jwtVer < serverPermVer;
}
